/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";
import { entity } from '../common/entity';
import { contact } from '../common/contact';
import { address } from '../common/address';
import { servicepaymentreference } from './servicepaymentreference';

export class payment extends IceEntity {
  payment_key: string = "";
  trans_account: string = "";
  subscriber_key: string = "";
  entity_key: string = "";
  address_key: string = "";
  pay_date: any = NaN;
  reference_num: string = "";
  total_paid: number = 0.0;
  cash_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  trans_type_code: IceTypes.TRANSTYPE = IceTypes.TRANSTYPE.itNone;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  payment_response: string = "";
  billed_to: string = "";

  ENTS: entity[] = [];
  CONS: contact[] = [];
  ADS: address[] = [];
  SERVICES: servicepaymentreference[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
    return "PAYMENT";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "CONS") return true;
    else if (ColumnName == "ADS") return true;
    else if (ColumnName == "ENTS") return true;
    else if (ColumnName == "SERVICES") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "CONS") return "CONTACT";
    else if (ColumnName == "ADS") return "ADDRESS";
    else if (ColumnName == "ENTS") return "ENTITY";
    else if (ColumnName == "SERVICES") return "SERVICE_PAYMENT_REFERENCE";

    return null;
  }
}
